import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
        title: {
            color: '#4D4F5C',
            fontSize: '40px',
            textAlign: 'center',
            opacity: 1,
            fontWeight: 300,
            '@media (max-width: 1050px)': {
                fontSize: 20
            }
        },
        legend: {
            color: '#4D4F5C',
            fontSize: '18px',
            textAlign: 'center',
            opacity: 1,
            fontWeight: 300
        }
    })
)

const QuizResultTitle = ({ type, title, numberOfQuestions }) => {
    const classes = useStyles();

    return (
        <>
        <Typography gutterBottom variant="h5" component="h1" className={classes.title}>
            {title !== undefined ? type + ' - ' + title : type}
        </Typography>
        {numberOfQuestions ? (
            <Typography gutterBottom variant="h6" component="h1" className={classes.legend}>
                {`Total de questões: ${numberOfQuestions}`}
            </Typography>
        ) : false}
    </>
    )
}

export default QuizResultTitle